import { useRef } from "react";
import UsersDataTable from "../components/UsersDataTable";

function UsersPage() {
    const usersTableRef = useRef(null);

    return (
        <section>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h1 className="h4 mb-1">Utilisateurs</h1>
                    <p className="text-secondary mb-0">Panel administrateur - gestion des utilisateurs.</p>
                </div>
                <button
                    type="button"
                    className="btn btn-primary btn-sm d-inline-flex align-items-center gap-1"
                    onClick={() => usersTableRef.current?.openCreateUserModal?.()}
                >
                    <i className="bi bi-person-plus" aria-hidden="true" />
                    <span>Créer un utilisateur</span>
                </button>
            </div>

            <UsersDataTable ref={usersTableRef} />
        </section>
    );
}

export default UsersPage;
